import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../../models/grid-item.interface';
import { GridSetting } from '../models/grid-setting.interface';
import { GridItemValueTransformerPipe } from './grid-item-value-transformer.pipe';
import { includes } from 'lodash';

@Pipe({
  name: 'appGridItemListFilter'
})
export class GridItemListFilterPipe implements PipeTransform {
  constructor(private _gridItemValueTransformerPipe: GridItemValueTransformerPipe) {
  }

  transform(items: GridItem[], filterText: string, gridSetting: GridSetting,
            isFlagFilterActive: boolean, isWarningFilterActive: boolean) {
    let filteredItems = items;

    if (filterText) {
      filteredItems = this._filterItemsByText(filteredItems, filterText, gridSetting);
    }

    if (isFlagFilterActive) {
      filteredItems = this._filterItemsByFlag(filteredItems);
    }

    if (isWarningFilterActive) {
      filteredItems = this._filterItemsByWarnings(filteredItems);
    }

    return filteredItems;
  }

  private _filterRowsByString(transformedValue, filterText): boolean {
    return transformedValue && transformedValue.toString().toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) !== -1;
  }

  private _filterItemsByText(items: GridItem[], filterText: string, gridSetting: GridSetting): GridItem[] {
    let filteredByTextArray: GridItem[] = [];
    for (let row of items) {
      for (let column of Object.keys(row)) {
        const columnModel = this._getColumnModelByProperty(column, gridSetting);
        if (columnModel) {
          const transformedValue = this._gridItemValueTransformerPipe.transform(row, columnModel);
          if (!this._isColumnHidden(column, gridSetting) && this._filterRowsByString(transformedValue, filterText) && !includes(filteredByTextArray, row)) {
            filteredByTextArray.push(row);
          }
        }
      }
    }
    return filteredByTextArray;
  }

  private _filterItemsByFlag(items: GridItem[]): GridItem[] {
    let filteredByFlagArray: GridItem[] = [];
    for (let row of items) {
      if (row.Flagged && !includes(filteredByFlagArray, row)) {
        filteredByFlagArray.push(row);
      }
    }
    return filteredByFlagArray;
  }

  private _filterItemsByWarnings(items: GridItem[]): GridItem[] {
    let filteredByWarningsArray: GridItem[] = [];
    for (let row of items) {
      if (row.columnsShouldBeWarned && row.columnsShouldBeWarned.length) {
        filteredByWarningsArray.push(row);
      }
    }
    return filteredByWarningsArray;
  }

  private _isColumnHidden(column: string, gridSetting: GridSetting): boolean {
    if (!column || !gridSetting) {
      return true;
    }
    const columnDef = this._getColumnModelByProperty(column, gridSetting);
    if (!columnDef) {
      return true;
    }
    const columnSetting = gridSetting.columnSettings.find(col => col.id === columnDef.id);
    if (!columnSetting) {
      return true;
    }
    return columnSetting.isHidden;
  }

  private _getColumnModelByProperty(column: string, gridSetting: GridSetting) {
    return gridSetting.columnConfig.find(userFacingColumn => userFacingColumn.valueProperty === column);
  }
}
